export default function (props: any) {
    return (
        <svg
            width="38px"
            height="44px"
            viewBox="0 0 38 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-Smart-Generator-(Dual-Fuel)" transform="translate(-822.000000, -6074.000000)" fill="#FF5641" fillRule="nonzero">
                    <g id="编组-36" transform="translate(612.000000, 6074.000000)">
                        <g id="Saving-fuel" transform="translate(210.000000, 0.000000)">
                            <path
                                d="M34.58,44 L3.42000001,44 C1.52000002,44 0,42.5542857 0,40.7314286 L0,7.54285714 C0,5.72 1.51999998,4.27428573 3.42000001,4.27428573 L5.32,4.27428573 C4.6902783,3.84938929 4.31138116,3.14429872 4.30666668,2.38857141 C4.30666668,1.06857141 5.4466667,0 6.77666665,0 L17.1633333,0 C18.5566667,0 19.6333334,1.06857141 19.6333333,2.38857141 C19.6333333,3.45714282 18.8733333,4.4 17.86,4.65142859 L17.86,5.15428573 L36.5433333,17.16 C37.43,17.7257143 38,18.7942857 38,19.8628571 L38,40.7314286 C38,42.4914286 36.48,44 34.58,44 Z M3.42000001,6.85142859 C2.91333335,6.85142859 2.53333334,7.16571432 2.53333334,7.54285714 L2.53333334,40.6685714 C2.53333334,41.0457143 2.91333335,41.36 3.42000001,41.36 L34.58,41.36 C35.0866666,41.36 35.4666667,41.0457143 35.4666667,40.6685714 L35.4666667,19.8628571 C35.4666667,19.6742857 35.34,19.4228571 35.15,19.2971429 L15.3266667,6.6 L15.3266667,2.57714286 L8.42333333,2.57714286 L8.42333333,6.85142859 L3.42000001,6.85142859 Z"
                                id="形状"
                            ></path>
                            <path
                                d="M24.2869343,34.5365853 C22.9887812,35.7723577 21.0415518,36.4878049 19.0294146,36.4878049 C15.1349556,36.4878049 11.9544807,33.8211382 11.9544807,30.5691057 C11.8895731,30.1788618 11.8895731,26.601626 17.9259845,18.601626 L18.9645069,17.1707317 L20.067937,18.5365854 C20.2626599,18.796748 25.5850872,25.5609756 26.0394408,30.504065 C26.1692561,31.9349593 25.5850872,33.3658536 24.2869343,34.5365853 Z"
                                id="路径"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
